import Vue from 'vue'

const mixins = Vue.mixin({
    data: () => ({
        requiredField: v => v && v.length > 0 || 'This field is required',
        requiredFileField: v => !!v || 'This field is required',
        requiredPricingModel: v => v && v > 0 || 'Pricing model is required',
        requiredDescription: v => v && v.length > 0 || 'Description field is required',
        requiredAudience: v => v && v > 0 || 'Limit audience must be greater then 0',
    }),
    methods: {
        //
    },
    computed: {
        //
    }
})

export default mixins